import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  selectCartConflict,
  selectCartConflictMessage,
  resetConflict,
} from "../../redux/Slices/cartSlice.js";

const CartConflictToast = () => {
  const dispatch = useDispatch();
  const isConflict = useSelector(selectCartConflict);
  const conflictMessage = useSelector(selectCartConflictMessage);

  useEffect(() => {
    if (isConflict) {
      const timer = setTimeout(() => {
        dispatch(resetConflict());
      }, 6000);
      return () => clearTimeout(timer);
    }
  }, [isConflict, dispatch]);

  if (!isConflict) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: "20px",
        right: "20px",
        zIndex: 99999,
        maxWidth: "420px",
        background: "#ffffff",
        color: "#1f2937",
        boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.15), 0 8px 10px -6px rgba(0, 0, 0, 0.1)",
        borderRadius: "12px",
        borderLeft: "5px solid #f59e0b",
        padding: "16px",
        display: "flex",
        alignItems: "flex-start",
        gap: "12px",
        animation: "fadeIn 0.3s ease-in-out",
      }}
    >
      <div style={{ color: "#f59e0b", fontSize: "20px", lineHeight: "1" }}>
        ⚠️
      </div>
      <div style={{ flex: 1 }}>
        <h6 style={{ margin: "0 0 4px 0", fontWeight: "600", fontSize: "14px" }}>
          Cart Synchronized
        </h6>
        <p style={{ margin: 0, fontSize: "13px", color: "#4b5563" }}>
          {conflictMessage ||
            "Your cart was modified in another tab or session. We've updated it to the latest version."}
        </p>
      </div>
      <button
        onClick={() => dispatch(resetConflict())}
        style={{
          background: "none",
          border: "none",
          color: "#9ca3af",
          cursor: "pointer",
          fontSize: "16px",
          padding: 0,
          marginLeft: "8px",
        }}
        aria-label="Close"
      >
        ✕
      </button>
    </div>
  );
};

export default CartConflictToast;
